import { PageContextProps } from 'application/contexts/PageContext';
import { queryCDA } from './queryCDA';

export const getSiteContent = (content) => {
	let arrayOfSiteSettings = [];
	arrayOfSiteSettings = content.properties.siteSettings?.items?.map((setting) => {
		const { properties, contentType } = setting?.content ?? {};
		switch (contentType) {
			case 'chatbot':
				return { chatbot: properties };
			case 'segmentAreas':
				return { segmentAreas: properties };
			case 'languagePicker':
				return { languagePicker: properties };
			case 'loginConfiguration':
				return { loginConfiguration: properties };
			case 'searchConfiguration':
				return { searchConfiguration: properties };
			case 'globalLinks':
				return { globalLinks: properties };
			case 'readSpeaker':
				return { readSpeaker: properties };
			case 'adobeTracking':
				return { adobeTracking: properties };
			case 'contactBoxWaitTime':
				return { contactBoxWaitTime: properties };
			case 'homePageRedirectUrl':
				return { homePageRedirectUrl: properties };
			case 'applicationInsights':
				return { applicationInsights: properties };
			case 'siteSettingsTransportLinks':
				return { transportLinks: properties };
			case 'experimental':
				return { experimental: properties };
		}
	});

	let siteSettings: Partial<Models.Settings.Site>;
	if (arrayOfSiteSettings) {
		siteSettings = Object.assign({}, ...arrayOfSiteSettings);
	}

	return {
		settings: siteSettings,
		siteMobileNavigationItems: content.properties.mobileNavigationItems || null,
		siteNavigationItems: content.properties.navigationItems?.items?.map((item) => item.content.properties) || null,
		title: content.properties.siteTitle,
		theme: content.properties.siteTheme,
	};
};

export const getSiteFromCDA = async (pageContext: Partial<PageContextProps>): Promise<Models.Site> => {
	const data = await queryCDA({
		pageContext,
		url: 'umbraco/delivery/api/v2/content',
		urlParams: {
			filter: 'contentType:homePage',
			fields: 'properties[mobileNavigationItems,navigationItems,siteSettings,siteTheme,siteTitle]',
			expand: 'properties[siteSettings[$all]]',
			take: '20',
		},
		requestType: 'site',
	});

	const site = data?.items?.find((item) => {
		const websiteHost = pageContext.host.toLocaleLowerCase();
		const cmsTheme = item?.properties?.siteTheme?.toLocaleLowerCase();
		let cmsSite = cmsTheme;
		let siteName = '';

		switch (cmsTheme) {
			case 'sanst':
				cmsSite = 'skatteankestyrelsen';
				siteName = 'Skatteankestyrelsen|Tax Appeals Agency';
				break;
			case 'sktfv':
				cmsSite = 'skatteforvaltningen';
				break;
		}

		if (websiteHost.includes('dev-dxp-web-archive')) {
			return websiteHost;
		}

		return websiteHost.includes(cmsSite) && ((siteName !== '' && siteName.includes(item.name)) || siteName === '');
	});

	// Localhost doesnt match with site themes
	// WEBGUIDE, UFST, SKAT, MOTORST ...
	const currentSite = pageContext?.host?.includes('localhost') ? data?.items?.find((item) => item?.properties?.siteTheme === 'WEBGUIDE') : site;
	return currentSite;
};
